import filesize from 'filesize';

export default (value: number): string => filesize(value, { base: 10 });
